<template>
	<div>
		<div class='a-trips'>
			<div class='app-container app-container-fluid a-container'>
				<div class="a-trips__container">
					<trips-header @click='edit = $event' :progress='getProgress'>
						<template v-slot:status>
							<p class='a-trips__header-title bold' v-if='!lastResult'>{{$t('account.search.download_results')}}</p>
							<p class='a-trips__header-title' v-else-if='initialItems.length === 0'>{{$t('account.search.total_number_of_options')}}: <span>(0)</span></p>
							<p class='a-trips__header-title bold' v-else>{{$t('account.search.choose_want.car')}}</p>
						</template>
						<template v-slot:title>
							<!-- <p class='a-trips__header-title'>{{source.airport.name}}</p> -->
						</template>
						<template v-slot:info>
							<p class='a-trips__header-text'>
								{{$moment(source.dateFrom).format("MMM DD, HH:mm")}} - {{$moment(source.dateTo).format("MMM DD, HH:mm")}}
							</p>
						</template>
					</trips-header>

					<trips-preloader
						name='cars'
						:title='!lastResult ? $t("account.search.preloader.cars.checking") : $t("account.search.preloader.cars.no_available")'
						:text='!lastResult ? `${$t("account.search.preloader.we_check_hundreds_of_options")}...` : $t("account.search.preloader.we_could_not_find_the_results")'
						v-if='!progress.some(() => true) || initialItems.length === 0'
					>
						<template v-slot:list v-if='lastResult'>
							<v-button small color='green white--text' :to="$i18nRoute({ name: 'cars' })">{{$t('account.search.change_search')}}</v-button>
							<ul class='a-trips-search-list'>
								<li class='a-trips-search-list-item'>{{$t('account.search.try_choose_alternate_dates')}}</li>
							</ul>
						</template>
					</trips-preloader>

					<trips-skeleton-card
						v-else-if='loading'
					/>

					<template v-else>
						<div class='row flex-nowrap'>
							<div class="col-auto a-trips-sidebar-col-auto">
								<trips-sidebar
									v-model='mobile_sidebar'
									:items='initialItems'
									:filters='filters'
									:filtersItems='filtersItems'
									@update-filters='updateFilter($event)'
									@reset-filters='resetFilter($event)'
									@clear-filters='filters = {}'
								/>
							</div>
							<div class='col'>
								<div class="a-trips__main">
									<div class='row'>
										<div class="col">
											<v-button block xxsmall outline color='green' class='tablet-show a-card-mobile-btn' @click='mobile_sidebar = true'>{{$t("account.sidebar.filters")}}</v-button>
										</div>
									</div>

									<div class='a-trips-content'>
										<div v-for='(item, i) in paginationItems' :key='i'>
											<trips-card
												:item='item'
												@open-details='details = true'
												:comparison='items_compare.find(el => el.code === item.code)'
												@update-compare='updateСompare($event, item)'
											/>
										</div>

										<v-pagination
											:total='initialItems.length'
											:page='page'
											:perPage='perPage'
											@update-pagination='page = $event'
											v-if='initialItems.length'
										/>

										<trips-preloader
											name='cars'
											:title='$t("account.search.preloader.cars.no_found")'
											v-if='paginationItems.length === 0'
										/>
									</div>
								</div>
							</div>
						</div>
					</template>
				</div>
			</div>
		</div>

		<trips-edit
			:title='$t("account.search.title.cars")'
			v-model='edit'
			@input='edit = $event'
		>
			<template>
				<a-home-cars :edit='true' @update='edit = false, getCarsSearch()' />
			</template>
		</trips-edit>

		<trips-details
			v-model='details'
			@close-dialog='details = false'
		/>

		<trips-comparison
			:items='items_compare'
			@clear-compare='items_compare = []'
			nameRoute='comparison-cars'
		/>
		<trips-time @update-search='getCarsSearch()'
			link='cars'
			:title='$t("account.search.cars.car")'
			:text='$t("account.search.cars.cars")'
			:edit="edit"
		/>
	</div>
</template>

<script>
	import TripsHeader from '@/views/account/search/components/header';
	import TripsPreloader from '@/views/account/search/components/preloader';
	import TripsSkeletonCard from '@/views/account/search/cars/skeleton-card';
	import TripsSidebar from '@/views/account/search/cars/sidebar';
	import TripsCard from '@/views/account/search/cars/card';
	import TripsEdit from '@/views/account/search/components/edit';
	import AHomeCars from "@/views/account/home/cars";
	import TripsTime from '@/views/account/search/components/time';
	import TripsComparison from '@/views/account/search/components/comparison';
	// import { getCarsSearch } from '@/services/request';
	import TripsDetails from '@/views/account/details/cars';
	import { disablePageScroll, enablePageScroll } from 'scroll-lock';
	import _ from 'lodash'

	export default {
		data: () => ({
			loading: false,
			initialItems: [],
      page: 1,
      perPage: 10,
			lastResult: false,
			progress: [],
			edit: false,
			items_compare: [],
			details: false,
			filters: {},
			mobile_sidebar: false
		}),
		components: {
			TripsHeader,
			TripsPreloader,
			TripsSkeletonCard,
			TripsSidebar,
			TripsCard,
			TripsEdit,
			AHomeCars,
			TripsComparison,
			TripsDetails,
			TripsTime
		},
		computed: {
			getProgress() {
				if(!this.progress) return;
				return this.progress.filter(el => el === true).length * 100 / this.progress.length;
			},
			source() {
				if(!this.$route.query.source) return;
				return JSON.parse(this.$route.query.source);
			},
			filtersItems() {
				return _.flattenDeep(Object.values(this.filters)).length ? this.updateItems() : this.initialItems;
			},
			paginationItems() {
				return this.filtersItems.slice(this.page === 1 ? 0 : this.perPage * (this.page - 1), this.perPage * this.page);
			}
		},
		created() {
			this.getCarsSearch()
		},
		methods: {
			updateFilter($event) {
				this.filters = {...this.filters, ...$event};
				this.page = 1;
				window.scrollTo({
					top: 0,
					behavior: "smooth"
				});
				this.updateItems();
			},
			resetFilter(name) {
				delete this.filters[name];
				this.updateFilter();
			},
			filterArray(array, filters) {
				const filterKeys = Object.keys(filters);
				return array.filter((item) => filterKeys.every((key) => {
					if(filters[key] === null || filters[key].length === 0) return item;
					return filters[key].indexOf(String(_.get(item, key))) !== -1
				}));
			},
			updateItems() {
				return this.filterArray(this.initialItems, this.filters)
			},
			getCarsSearch() {
				this.loading = this.progress.some(() => true);

				this.initialItems = [{}];
				this.lastResult = true;
				this.loading = false;
				this.progress = [true];

				// getHotelSearch(this.$route.params.storageId).then(res => {
				// 	if(res.data !== null) {
				// 		this.initialItems = res.data.offers;

				// 		this.lastResult = res.data.lastResult;
				// 		this.progress = res.data.progress;

				// 		if(!this.lastResult) {
				// 			setTimeout(() => this.getHotelSearch(), 3000);
				// 		}
				// 		if(this.progress.some(() => true)) {
				// 			setTimeout(() => this.loading = false, 1500);
				// 		}
				// 	} else {
				// 		this.initialItems = [];
				// 		this.lastResult = true;
				// 		this.progress = [];
				// 	}
				// })
			},
			updateСompare(name, item) {
				if(name === "delete") {
					this.items_compare = this.items_compare.filter(el => el.code !== item.code);
				} else {
					if (this.items_compare.length >= 6) {
						this.$store.commit('notification/errorMessage', {status: 'warning', title: this.$t('account.comparison.it_is_impossible.cars')})
					} else {
						this.items_compare.push(item)
					}
				}
			}
		},
		watch: {
			mobile_sidebar() {
				setTimeout(() => {
					const hideEl = document.querySelector('.a-sidebar')
					this.mobile_sidebar ? disablePageScroll(hideEl) : enablePageScroll(hideEl)
				}, 150)
			},
			"$route.params.storageId"() {
				this.edit = false;
				this.initialItems = [];
				this.page = 1;
				this.lastResult = false;
				this.progress = [];
				this.filters = {};

				this.getCarsSearch()
			}
		}
	}
</script>
